/**
 * Landing page test. The new landing page (components/landing-test) is the page at "/".
 * The previous home page is NOT routed anywhere; its code is kept in components/home-v2/ClassicHome.tsx
 * so it can be restored: make app/(navbarScreens)/page.tsx render <ClassicHome /> again.
 * Once the test is decided, delete whichever one lost.
 */
export const LOGGED_OUT_HOME_PATH = '/'
